<template>
  <validation-observer ref="documentValidationRef" novalidate tag="form">
    <div class="bg-white rounded p-4">
      <div class="row">
        <div class="col-md-12 mb-3">
          <em class="fas fa-plus text-orange mr-1" />
          <span class="color-gray-7 font-weight-bold font-16">
            Anejar Determinación de Ética
          </span>
        </div>
        <div class="col-md-9">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-file-input
              v-model="document.file"
              accept=".pdf"
              :attachment-id="document.fileId"
              custom-error-msg="Favor seleccionar un documento."
              display-style="normal"
              :error="errors[0]"
              :name="document.filename"
              required
              @input="onFileAdded($event)"
            />
          </validation-provider>
        </div>
        <div class="col-3">
          <action-button
            class="float-right mr-3"
            i="fas fa-times-circle"
            type="button"
            variant="btn btn-outline-danger btn-cancel danger"
            @click="onCancel()"
          >
            Cancelar
          </action-button>
          <action-button
            class="float-right mr-3"
            i="fas fa-file-plus"
            type="button"
            variant="success"
            @click="onAddDocument()"
          >
            Anejar
          </action-button>
        </div>
      </div>
    </div>
  </validation-observer>
</template>

<script>
import CustomFileInput from 'CustomFileInput';
import ActionButton from 'ActionButton';
import alertMixin from 'utils/mixins/alert.mixin.js';
import exemptionFileType from '@/utils/shared/constants/exemptionFileType';
import { serialize as objectToFormData } from 'object-to-formdata';
import { uploadExemptionDocument as _uploadExemptionDocument } from '@/modules/provider/api';

export default {
  name: 'AddEthicLetter',
  components: {
    CustomFileInput,
    ActionButton,
  },
  mixins: [alertMixin],
  props: {
    exemptionRequestId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    document: {
      file: null,
      filename: null,
      documentType: null,
    },
  }),
  methods: {
    onFileAdded(file) {
      this.document.filename = file.name;
      this.document.documentType = file.type;
    },
    async onAddDocument() {
      const isValid = await this.$refs.documentValidationRef.validate();
      if (!isValid) {
        this.ShowToast('Alerta', 'Información Incompleta', 'error');
        return;
      }

      let payload = objectToFormData({
        name: this.document.filename,
        required: false,
        file: this.document.file,
        fileName: this.document.filename,
        exemptionFileTypeId: exemptionFileType.EthicDeterminationLetter,
        exemptionRequestId: this.exemptionRequestId,
      });

      await _uploadExemptionDocument(payload)
        .then(() => {
          this.ShowToast(
            '',
            'El documento ha sido anejado exitosamente.',
            'success'
          );
          this.$emit('on-refresh');
        })
        .catch(() =>
          this.ShowToast('Alerta', 'Error anejando documento', 'error')
        );
    },
    onCancel() {
      this.document = {
        file: null,
        filename: null,
        documentType: null,
      };
      this.$emit('on-cancel');
    },
  },
};
</script>
